import { useEffect } from "react";
import { useRouter } from "next/router";

import { useConsentStore } from "@/consent/useConsentStore";
import { getOrCreateVisitorId } from "@/utils/visitorId";

function identify(): void {
  try {
    if (typeof window === "undefined" || typeof window.ire !== "function")
      return;
    window.ire("identify", {
      customerId: "",
      customerEmail: "",
      customProfileId: getOrCreateVisitorId(),
    });
  } catch (error) {
    console.error("Failed to fire Impact identify:", error);
  }
}

export default function ImpactIdentify(): null {
  const router = useRouter();
  const marketing = useConsentStore((s) => s.consent.marketing);

  useEffect(() => {
    if (!marketing) return;
    identify();
    router.events.on("routeChangeComplete", identify);
    return () => {
      router.events.off("routeChangeComplete", identify);
    };
  }, [router.events, marketing]);

  return null;
}
